import { useMemo } from "react";

const normalize = (value) =>
  String(value ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const useSearch = (items, search, fields) => {
  return useMemo(() => {
    const q = normalize(search);
    const tokens = q.split(/\s+/).filter(Boolean);

    if (!tokens.length) return items;

    return items.filter((item) => {
      const haystack = normalize(fields.map((f) => item[f]).join(" "));
      return tokens.every((t) => haystack.includes(t));
    });
  }, [items, search, fields]);
};
